import React from 'react'

import History from '@/Helpers/History'
import useTranslation from '@/Hooks/UseTranslation'
import ContentHeader from '@/Layouts/MainLayout/components/ContentHeader'
import { TASKS_NAVIGATION, TasksTab } from './tasks-navigation'

interface Props {
  activeTab: TasksTab
  children?: React.ReactNode
  projectId: string
  subtitle?: string
}

const TasksHeader = ({ activeTab, children, projectId, subtitle }: Props) => {

  const { t } = useTranslation()

  const tabs = TASKS_NAVIGATION.map((tab) => ({
    label: t(tab.translationKey),
    icon: <i className={tab.icon} />,
    onClick: () => History.push(`/project/${projectId}${tab.path}`),
    active: activeTab === tab.id,
    disabled: !projectId,
  }))

  return (
    <ContentHeader
      className="pl4-tasks-header pl4-page-header"
      title={t('TASKS:PageTitle')}
      subtitle={subtitle}
      navTabs={tabs}
    >
      {children}
    </ContentHeader>
  )
}

export default TasksHeader
